// extracted by mini-css-extract-plugin
export default {"LoginForm":"styles_LoginForm__K1wBX","fieldsWrapper":"styles_fieldsWrapper__+IEB9"};